import React, { useEffect, useState, useCallback } from "react";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GraphQLClient } from "graphql-request";

import Header from "../../components/Header";
import ThemedDataGrid from "../../components/ThemedDataGrid";
import TableActions from "../../components/TableActions";
import TenantSelector from "../../components/TenantSelector";
import { useTenant } from "../../context/TenantContext";

import { graphqlEndpoint } from "../../config";
import { ARCHIVE_TENANT_USER } from "../../graph/tenantUsers/mutations";


const client = new GraphQLClient(graphqlEndpoint);

const ManageTenantUsers = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const { tenantId } = useTenant();

  const fetchData = useCallback(async () => {
    // TODO: replace with real query when added
    setRows([]);
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleArchive = async (row) => {
    await client.request(ARCHIVE_TENANT_USER, { id: row.id });
    fetchData();
  };

  const columns = [
    { field: "userId", headerName: "User ID", flex: 1 },
    { field: "accessRole", headerName: "Access Role", flex: 1 },
    {
      field: "actions",
      flex: 1,
      renderCell: ({ row }) => (
        <TableActions
          onEdit={() => navigate(`/system/users/edit/${row.id}`)}
          onDelete={() => handleArchive(row)}
          hideCreate
        />
      ),
    },
  ];

  return (
    <Box>
      <Box display="flex" justifyContent="space-between">
        <Header title="TENANT USERS" subtitle="Manage Tenant Users" />
        <Button onClick={() => navigate("/system/users/create")} variant="contained">
          Create Tenant User
        </Button>
      </Box>

      <ThemedDataGrid rows={rows} columns={columns} />
    </Box>
  );
};

export default ManageTenantUsers;